module.exports = __webpack_public_path__ + "img/hr-train-wheels-shadow-2.8885c093.png";